import React, { useEffect } from "react";

/* ============================================================
   Number Sense — replay chooser for a completed path node.
   A finished lesson with a timed groove finale can be replayed
   two ways: from the top, or jumping straight to the groove.
   Backdrop tap / Escape / × dismisses without starting anything.
   ============================================================ */
const GrooveChoice = ({ label, onFull, onGroove, onClose }) => {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div className="ns-root ns-modal-root">
      <div className="ns-choice-backdrop" onClick={onClose} />
      <div className="ns-choice" role="dialog" aria-label="replay options">
        <button
          type="button"
          className="ns-choice-close"
          onClick={onClose}
          aria-label="close"
        >
          ×
        </button>
        <div className="ns-choice-title">already nailed this one</div>
        <div className="ns-choice-sub">
          {label ? `${label} — ` : ""}run it back from the top, or jump straight
          to the groove.
        </div>
        <button type="button" className="btn" onClick={onGroove}>
          Straight to the groove
        </button>
        <button type="button" className="btn ghost" onClick={onFull}>
          Restart the lesson
        </button>
      </div>
    </div>
  );
};

export default GrooveChoice;
